var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.91,18.7c0-.62,0-1.2,0-1.78,0-.96.01-1.93,0-2.89-.02-1.68-1.3-2.95-2.98-2.96-1.51,0-3.03,0-4.54,0-.03,0-.06-.01-.13-.03.05-.13.09-.25.15-.37.78-1.57,1.58-3.14,2.35-4.72.13-.27.29-.37.59-.37,1.07.02,2.14,0,3.21.02.35,0,.58-.09.79-.4,1.39-2.08,3.31-3.39,5.77-3.87,1.34-.26,2.67-.15,4,.09.28.05.36.2.41.45.84,3.91-.5,7.44-3.75,9.72-.33.23-.46.46-.45.85.03,1.07.02,2.14,0,3.21,0,.17-.12.42-.26.5-1.64.85-3.3,1.66-4.95,2.49-.04.02-.08.02-.22.06Zm1.13-6.69c1.71-.53,3.33-1.16,4.67-2.35,1.92-1.71,2.62-3.87,2.42-6.38-.02-.27-.09-.42-.39-.44-2.48-.18-4.65.45-6.37,2.35-1.18,1.3-1.83,2.87-2.34,4.51-.03.09.04.28.11.33.8.48,1.45,1.11,1.89,1.98Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1.23,18.81c-.06-1.7.03-3.29.75-4.75.97-1.96,3.14-2.45,4.75-1.12,1.41,1.17,1.36,3.5-.09,4.62-.97.75-2.12.99-3.29,1.12-.68.08-1.36.09-2.11.13Zm2.06-2.32c.06.06.12.12.18.19.51-.12,1.04-.19,1.52-.37.49-.18.68-.63.59-1.12-.08-.44-.38-.75-.82-.81-.5-.08-.94.11-1.12.59-.18.49-.24,1.01-.36,1.52Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.82,4.77c.73,0,1.33.59,1.35,1.33.02.76-.58,1.39-1.33,1.39-.73,0-1.33-.59-1.35-1.33-.02-.76.58-1.39,1.33-1.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/Rocket.51ff1d270e8d84176ec923bbb6f84e79.svg";
export { ForwardRef as ReactComponent };